import { ImageProperties } from './image-properties.model';
export class Diagram {
public Label: string;
public Location: string;
public ImageProperty: ImageProperties;
}

function Diagram_tsickle_Closure_declarations() {
/** @type {?} */
Diagram.prototype.Label;
/** @type {?} */
Diagram.prototype.Location;
/** @type {?} */
Diagram.prototype.ImageProperty;
}

